<template>
    <v-app light class="white" :class="{
            'md-up': $vuetify.breakpoint.mdAndUp,
            'sm-up': $vuetify.breakpoint.smAndUp,
            'md-down': $vuetify.breakpoint.mdAndDown,
            'sm-down': smAndDown
            }" v-scroll="seHaceScroll">
        <v-app-bar app :absolute="!mdAndDown" :height="alturaAppBar" :color="colorAppBar"
                   elevation="0" class="pt-2 barra-app" style="padding-top: 30px"
                   :class="{'home': esHome, 'ancho-limitado': !esAnchoNoLimitado, 'ancho-no-limitado': esAnchoNoLimitado}">
            <v-app-bar v-if="topbar" fixed flat style="background: #40108f!important" height="30">
                <!-- Contenido de la barra superior -->
            </v-app-bar>
            <v-img class="logo" position="left center" contain style="margin-top: 0px"
                   :src="require(`../assets/logo${smAndDown ? '_blanco' : ''}.png`)"
                   :max-width="esHome ? 120 : 90" :height="alturaBtnInicio" @click="goTo('/')"/>

            <v-spacer/>
            <v-app-bar-nav-icon class="white--text hidden-md-and-up" @click="menuLateral = !menuLateral"/>
            <div class="hidden-sm-and-down" style="margin-top: 0px">
                <v-btn text color="primary" to="/biblioteca">
                    <span class="mr-2 font-weight-black">{{ $t('biblioteca') }}</span>
                </v-btn>
                <!--        <v-btn text color="primary" to="/descargas">-->
                <!--          <span class="mr-2">{{ $t('descargas') }}</span>-->
                <!--        </v-btn>-->
                <!--        <v-btn text color="primary" to="/info/introduccion">-->
                <!--          <span class="mr-2">{{ $t('metodologia') }}</span>-->
                <!--        </v-btn>-->
                <v-btn v-if="!usuario" text color="primary" to="/login">
                    <span class="mr-2 font-weight-black">{{ $t('iniciar_sesion') }}</span>
                </v-btn>
                <v-menu offset-y v-if="menuApp[8].mostrar">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text color="primary" v-bind="attrs" v-on="on">
                            <span class="mr-2 font-weight-black">{{ $t('administracion') }}</span>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in menuApp[8].menu" :key="index" @click="item.click()">
                            <v-list-item-title>{{ item.lang }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            <v-menu v-if="usuario" v-model="menuUsuario" offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn class="hidden-sm-and-down" text v-on="on" target="_blank" color="primary">
                        <span class="mr-2">{{ $t('usuario', [usuario.nombre]) }}</span>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="goTo('/perfil')">
                        <v-list-item-title class="primary--text">
                            {{ $tc('perfil', 1) | capitalize }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="goTo('/proyecto-guardado')">
                        <v-list-item-title class="primary--text">
                            {{ $tc('proyectos_guardados') | capitalize }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="goTo('/material-guardado')">
                        <v-list-item-title class="primary--text">
                            {{ $tc('materiales_guardados') | capitalize }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout()">
                        <v-list-item-title class="primary--text">
                            {{ $t('salir') | capitalize }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-snackbar v-if="snackBar" v-model="snackBar.mostrar" :color="snackBar.color" :style="styleSnackbar"
                    :top="!smAndDown" :bottom="smAndDown" :timeout="snackBar.timeout" absolute class="snackbar-z-index">
            <span v-html="snackBar.texto"/>
            <template v-slot:action="{}">
                <v-btn text @click="cerrarSnackBar()">
                    {{ $t("cerrar") | capitalize }}
                </v-btn>
            </template>
        </v-snackbar>

        <v-dialog v-if="confirmarDialogo" v-model="confirmarDialogo.mostrar" scrollable persistent
                  :max-width="smAndDown ? '80%' : '30%'">
            <v-card>
                <v-card-title class="white--text text-capitalize" :class="confirmarDialogo.color">
                    <span v-html="confirmarDialogo.titulo"/>
                </v-card-title>
                <v-divider/>
                <v-card-text class="pa-0" style="max-height: 300px;">
                    <v-container fluid class="body-1">
                        <span v-html="confirmarDialogo.texto"/>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-btn color="error" text v-if="confirmarDialogo.rechazar" depressed
                           @click="confirmarDialogo.rechazar">
                        Cerrar
                    </v-btn>
                    <v-spacer/>
                    <v-btn :color="confirmarDialogo.rechazar ? 'success': 'primary'" depressed
                           @click="confirmarDialogo.resolver">
                        {{ confirmarDialogo.rechazar ? "Confirmar" : "Aceptar" }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-navigation-drawer class="secondary" app temporary v-model="menuLateral">
            <v-list nav dense>
                <v-list-item class="mb-2" link>
                    <v-img max-width="30%" :src="require('../assets/logo.png')"></v-img>
                </v-list-item>
                <v-divider></v-divider>
                <div v-for="(opcion, i) in menuApp" :key="i">
                    <v-list-item v-if="!opcion.group" v-show="opcion.mostrar" link @click="opcion.click">
                        <v-list-item-content class="primary--text">
                            <v-list-item-title>{{ opcion.lang | capitalize }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group v-if="opcion.group" v-show="opcion.mostrar" no-action value="true">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ opcion.lang }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="(subOpcion, i) in opcion.menu" :key="i" link v-show="subOpcion.mostrar"
                                     @click="subOpcion.click" class="pl-6">
                            <v-list-item-content class="primary--text">
                                <v-list-item-title>{{ subOpcion.lang | capitalize }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </div>
            </v-list>
        </v-navigation-drawer>


        <v-main>
            <router-view :esIOS="esIOS"></router-view>
        </v-main>

        <v-footer color="primary pa-12 hidden-sm-and-down">
            <v-container fluid class="white--text ancho-limitado">
                <v-row no-gutters>
                    <v-col cols="12" md="4">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <p class="font-weight-bold">{{ $t('creada_por') }}</p>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" class="text-left">
                                <v-img
                                    :src="urlImagenS3('logo-diputacion.png')"
                                    contain
                                    position="center left"
                                    width="190"
                                    style="margin-bottom: 0 !important;"
                                ></v-img>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-12">
                            <v-col cols="12" class="text-left">
                                <v-img
                                    :src="urlImagenS3('logo-itc.png')"
                                    position="center left"
                                    contain
                                    width="190"
                                    style="margin-bottom: 0 !important;"
                                ></v-img>
                            </v-col>
                        </v-row>
                        <!--            <v-row no-gutters class="mt-12">-->
                        <!--              <v-col cols="12">-->
                        <!--                <p class="pa-0 ma-0 caption">-->
                        <!--                  {{ $t('disenyo') }}&nbsp;|&nbsp;-->
                        <!--                  <a class="white&#45;&#45;text" @click="goToExternal('http://sigogestion.com/')">-->
                        <!--                    {{ $t('programacion') }}-->
                        <!--                  </a>-->
                        <!--                </p>-->
                        <!--              </v-col>-->
                        <!--            </v-row>-->
                    </v-col>
                    <v-col cols="12" md="4" class="links pl-8">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <p class="caption font-weight-bold">
                                    <a class="white--text" @click="goTo('/opinion')">
                                        {{ $t('opinion') }}
                                    </a>
                                </p>
                                <p class="caption font-weight-bold">
                                    <a @click="goTo('aviso-legal')" class="white--text">
                                        {{ $t('aviso_legal') }}
                                    </a>
                                </p>
                                <p class="caption font-weight-bold"><a @click="goTo('politica-privacidad')"
                                                                       class="white--text">
                                    {{ $t('privacidad') }}
                                </a>
                                </p>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-8">
                            <v-col cols="12">
                                <p class="caption font-weight-bold">
                                    <a @click="goTo('/')" class="white--text">
                                        {{ $t('solconcer') }}
                                    </a>
                                </p>
                                <!--                <p class="caption font-weight-bold">-->
                                <!--                  <a @click="goTo('/info/introduccion')" class="white&#45;&#45;text">-->
                                <!--                    {{ $t('metodologia') }}-->
                                <!--                  </a>-->
                                <!--                </p>-->
                                <!--                <p class="caption font-weight-bold">-->
                                <!--                  <a @click="goTo('/descargas')" class="white&#45;&#45;text">-->
                                <!--                    {{ $t('descargas') }}-->
                                <!--                  </a>-->
                                <!--                </p>-->
                                <p class="caption font-weight-bold">
                                    <a @click="goTo('/biblioteca')" class="white--text">
                                        {{ $t('biblioteca') }}
                                    </a>
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4" class="pl-8">
                        <v-row no-gutters v-if="!usuario">
                            <v-col cols="12">
                                <login-component :en-footer="true"/>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="usuario" class="links">
                            <v-col cols="12">
                                <p class="caption font-weight-bold">
                                    <a @click="goTo('/perfil')" class="white--text">
                                        {{ $tc('perfil', 1) | capitalize }}
                                    </a>
                                </p>
                                <p class="caption font-weight-bold">
                                    <a @click="goTo('/proyecto-guardado')" class="white--text">
                                        {{ $tc('proyectos_guardados') | capitalize }}
                                    </a>
                                </p>
                                <p class="caption font-weight-bold">
                                    <a @click="goTo('/material-guardado')" class="white--text">
                                        {{ $tc('materiales_guardados') | capitalize }}
                                    </a>
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>

        </v-footer>

        <cookie-law theme="dark-lime" :buttonText="$t('acepto')">
            <div slot="message">
                {{ $t('cookie_mensaje') }}&nbsp;<a @click="goTo('politica-privacidad')"
                                                   class="secondary--text">{{ $t('cookie_aqui') }}</a>.
            </div>
        </cookie-law>
    </v-app>
</template>

<script>
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import LoginServicio from "../comunes/servicios/LoginServicio";
import CookieLaw from 'vue-cookie-law';
import {mapState} from 'vuex';
import {OCULTAR_SNACKBAR} from "@/store/store-app";
import LoginComponent from "@/components/LoginComponent";
import {AppConfig} from "@/comunes/helpers/AppConfig";

export default {
    name: 'PlantillaBase',
    components: {CookieLaw, LoginComponent},
    data: () => ({
        menuUsuario: false,
        colorBarra: "white",
        esHome: false,
        esIOS: false,
        esResultados: false,
        esAnchoNoLimitado: false,
        menuLateral: false,
        scrollY: '0px'
    }),
    mounted() {
        this.cambiaColorPorRuta("/");
    },
    computed: {
        ...mapState(["usuario", "snackBar", "confirmarDialogo"]),
        topbar() {
            return false;
        },
        menuApp() {
            return [
                {
                    click: () => {
                        this.goTo("/")
                    },
                    lang: this.$t('inicio'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("/biblioteca")
                    },
                    lang: this.$t('biblioteca'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("/descargas")
                    },
                    lang: this.$t('descargas'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("/proyecto-nuevo");
                    },
                    lang: this.$t('herramienta'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("/info/introduccion");
                    },
                    lang: this.$t('metodologia'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("aviso-legal");
                    },
                    lang: this.$t('aviso_legal'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("politica-privacidad");
                    },
                    lang: this.$t('privacidad'),
                    mostrar: true,
                    group: false,
                },
                {
                    click: () => {
                        this.goTo("/login");
                    },
                    lang: this.$t('iniciar_sesion'),
                    mostrar: !this.usuario,
                    group: false,
                },
                {
                    lang: this.$t('administracion'),
                    mostrar: this.usuarioEsAdmin(),
                    group: true,
                    menu: [
                        {
                            click: () => {
                                this.goTo("/admin-muestreos");
                            },
                            lang: this.$t('muestreos'),
                            mostrar: this.usuarioEsAdmin()
                        },
                        {
                            click: () => {
                                this.goTo("/admin-registro-descargas");
                            },
                            lang: this.$t('registro_descargas'),
                            mostrar: this.usuarioEsAdmin()
                        },
                        {
                            click: () => {
                                this.goTo("/admin-constantes");
                            },
                            lang: this.$t('constantes'),
                            mostrar: this.usuarioEsAdmin()
                        },
                        {
                            click: () => {
                                this.goTo("/admin-indicadores");
                            },
                            lang: this.$t('indicadores'),
                            mostrar: this.usuarioEsAdmin()
                        }
                    ]
                },
                {
                    lang: this.usuario ? this.$t('usuario', [this.usuario.nombre]) : "",
                    mostrar: this.usuario,
                    group: true,
                    menu: [
                        {
                            click: () => {
                                this.goTo("/admin-muestreos");
                            },
                            lang: this.$t('muestreos'),
                            mostrar: this.usuarioEsAdmin()
                        },
                        {
                            click: () => {
                                this.goTo("/admin-registro-descargas");
                            },
                            lang: this.$t('registro_descargas'),
                            mostrar: this.usuarioEsAdmin()
                        },
                        {
                            click: () => {
                                this.goTo("/perfil");
                            },
                            lang: this.$tc('perfil', 1),
                            mostrar: this.usuario
                        },
                        {
                            click: () => {
                                this.goTo("/proyecto-guardado")
                            },
                            lang: this.$tc('proyectos_guardados', 1),
                            mostrar: this.usuario
                        },
                        {
                            click: () => {
                                this.goTo("/material-guardado")
                            },
                            lang: this.$tc('materiales_guardados', 1),
                            mostrar: this.usuario
                        },
                        {
                            click: () => {
                                this.logout();
                            },
                            lang: this.$t('salir'),
                            mostrar: this.usuario
                        }
                    ]
                }
            ];
        },
        smAndDown() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        mdAndDown() {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        alturaAppBar() {
            if (this.$vuetify.breakpoint.mdAndDown) return undefined;
            if (this.esHome) return 190;
            return this.esResultados ? 120 : 160;
        },
        colorAppBar() {
            if (this.$vuetify.breakpoint.smAndDown) return "primary";
            return this.$route.path === "/" ? "secondary" : "white";
        },
        alturaBtnInicio() {
            if (this.$vuetify.breakpoint.mdAndDown) return undefined;
            return this.esHome ? 120 : 90;
        },
        styleSnackbar() {
            if (this.$vuetify.breakpoint.smAndDown) return undefined;
            return {'top': this.scrollY, 'height': 'initial'};
        }
    },
    watch: {
        "$route": {
            handler(router) {
                this.cambiaColorPorRuta(router.path);
            },
            deep: true
        }
    },
    methods: {
        seHaceScroll: function () {
            this.scrollY = `${Math.round(window.pageYOffset)}px`;
        },
        goTo(path) {
            VueRouteHelper.goTo(path, this.$router);
        },
        goToExternal(url) {
            location.replace(url);
        },
        cambiaColorPorRuta(path) {
            localStorage.setItem('esIOS', 1);
            if (this.$route.query.esIOS == 1 || localStorage.getItem('esIOS') == 1) {
                this.esIOS = true;
                localStorage.setItem('esIOS', 1);
            }
            this.esHome = path == "/";
            this.esResultados = path.includes('proyecto-detalles');
            this.esAnchoNoLimitado = path.includes('proyecto-detalles')
                || path.includes('admin-muestreos') || path.includes('admin-registro') || path.includes('proyecto-guardado')
                || path.includes('material-guardado');
            if (this.$vuetify.breakpoint.smAndDown) {
                this.colorBarra = "primary";
            } else {
                this.colorBarra = path == "/" ? "secondary" : "white";
            }
        },
        usuarioEsAdmin() {
            return this.$store.getters.usuarioEsAdmin;
        },
        logout() {
            LoginServicio.logout();
            this.menuUsuario = false;
        },
        cerrarSnackBar() {
            this.$store.commit(OCULTAR_SNACKBAR);
        },
        urlImagenS3(imagen) {
            return `${AppConfig.S3_URL}/imagenes/${imagen}`;
        }
    }
}
</script>

<style lang="scss">
.Cookie__button {
    background: #f7d9cd !important;
    color: #40108e !important;

    &:hover {
        background: #40108e !important;
        color: #f7d9cd !important;
    }
}

.logo {
    &:hover {
        background: #40108f1a;
        padding: -10px;
    }
}

.ancho-limitado {
    padding-left: calc(50% - 532px) !important;
    padding-right: calc(50% - 532px) !important;
}

.ancho-no-limitado {
    padding: 10px 50px;
}

.v-application.md-up {
    header.home {
        padding-left: calc(50% - 532px) !important;
        padding-right: calc(50% - 532px) !important;
    }

    .barra-app .v-toolbar__content {
        align-items: initial !important;
        padding: 0 !important;
    }
}

.v-application.md-down {
    .barra-app .v-toolbar__content {
        align-items: initial !important;
        padding: 0 15px !important;
    }

    header {
        padding: 10px !important;
        height: 70px !important;

        .barra-app-botones {
            text-align: right !important;
        }
    }

    header.home {
        padding-left: calc(50% - 480px) !important;
        padding-right: calc(50% - 480px) !important;
    }

    header {
        .logo {
            margin: 0 !important;
            height: 50px !important;

            .v-responsive__content {
                height: 50px !important;
            }

            .v-image__image {
                height: 48px !important;
            }
        }

        .v-toolbar__content {
            height: 70px !important;
        }
    }

    footer {
        padding: 20px !important;
        text-align: center !important;

        .text-left {
            text-align: center !important;
        }

        .v-image {
            margin: 0 auto !important;
            margin-bottom: 20px !important;
        }

        .col-md-4 {
            margin-bottom: 20px;
        }

        .links {
            a {
                font-size: 1rem !important;
            }
        }
    }

    .ancho-limitado {
        padding-left: calc(50% - 480px) !important;
        padding-right: calc(50% - 480px) !important;
    }
}

.v-toolbar__content {
    .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
        color: #1EE8B8 !important;
        opacity: 1 !important;
        border-radius: 0 !important;
    }
}

.barra-app .v-toolbar__content {
    align-items: initial !important;
    padding: 0 !important;
}

.v-btn {
    text-transform: none !important;
}

.v-card {
    border-radius: 0 !important;
}

.v-alert.info {
    background-color: #f7d9cd !important;
    color: #40108e !important;

    .v-icon, .v-icon::before {
        color: #40108e !important;
        font-size: 30px !important;
        margin-top: 3px !important;
    }
}

.v-breadcrumbs {
    padding: 6px !important;
}

</style>

<style lang="scss" scoped>
.links p {
    margin-bottom: 8px !important;
}

.logo {
    cursor: pointer;
}

.hand {
    cursor: pointer;
}

.hand:hover {
    text-decoration-line: underline;
}

.btn-inicio {
    min-width: 120px !important;
    min-height: 100% !important;
}

.snackbar-z-index {
    z-index: 10000;
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "solconcer": "Solconcer",
    "administracion": "Administración",
    "constantes": "Constantes",
    "indicadores": "Indicadores",
    "descargas": "Descargas",
    "metodologia": "Conoce la metodología",
    "usuario": "¡Hola {0}!",
    "creada_por": "Plataforma creada por: ",
    "disenyo": "Diseño Joan Rojeski Studio",
    "programacion": "Programación SiGO",
    "contacto": "Contacto",
    "herramienta": "Herramienta",
    "opinion": "Danos tu opinión",
    "aviso_legal": "Aviso legal",
    "privacidad": "Política de privacidad",
    "acepto": "Acepto",
    "cookie_mensaje": "Utilizamos cookies propias y de terceros para mejorar nuestros servicios. Si continua navegando, consideramos que acepta su uso. Puede obtener más información",
    "cookie_aqui": "aquí",
    "area_personal": "Área personal",
    "iniciar_sesion": "Iniciar sesión",
    "muestreos": "Muestreos",
    "registro_descargas": "Regis. Descargas",
    "proyectos_guardados": "Proyectos guardados",
    "materiales_guardados": "Materiales guardados",
    "biblioteca": "Biblioteca"
  }
}
</i18n>
<!--@formatter:on-->